import React, { Component } from 'react';

class Success extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoad: true
        }
    }

    componentDidMount() {
        // const that = this;
        // const url = window.url + '/api/resource/searchRoutes?fromCityID=' + srchPrm.fromCity.split('|')[0] + '&toCityID=' + srchPrm.toCity.split('|')[0] + '&journeyDate=' + getRevDate(srchPrm.departDate);
        // fetch(url).then(function(response){
        //     return response.json();
        // }).then(function(data) {
        //     store.dispatch(getSearchResults(data));
        // }).catch(function(error) {
        //     store.dispatch(getSearchResults(false));
        //     console.log('There has been a problem with your fetch operation: ' + error.message);
        // });
    }

    render() {
        return (
            <section style = { this.cardS }>
                <div style = { this.thankYouS }>
                    <span style = { this.tickWrapS }>
                        <i style = { this.tickS }></i>
                    </span>
                    <div>
                        <h5 style = { this.hS }>Thank you</h5>
                        <div style = {{ paddingLeft: '3px' }}>Ticket has been mailed to <b>{ 'ajesh@gmail.com' }</b> and a SMS has been sent to <b>{ '9901131516' }</b></div>
                    </div>
                </div>
                <div style = { this.routeInfoS }>
                    <div style = { this.routeDetS }>
                        <b style = {{ fontSize: '1rem' }}>{ 'Chandigarh' }</b>
                        <div>{ '12:15 AM - 14 Mar, 2018' }</div>
                        <span style = { this.arrS }></span>
                    </div>
                    <div style = {{ ...this.routeDetS, paddingLeft: '20%' }}>
                        <b style = {{ fontSize: '1rem' }}>{ 'Delhi' }</b>
                        <div>{ '12:15 AM - 14 Mar, 2019' }</div>
                    </div>
                </div>
                <div style = {{ paddingBottom: '30px' }}>
                    <div style = { this.tktInfoS }>
                        <div style = { this.routeDetS }>
                            <div>PNR</div>
                            <b>12743716-TS-YASA12212</b>
                        </div>
                        <div style = {{ ...this.routeDetS, paddingLeft: '20%' }}>
                            <div>Ticket No</div>
                            <b>1274371612212221</b>
                        </div>
                    </div>
                    <div style = { this.tktInfoS }>
                        <div style = { this.routeDetS }>
                            <div>Seat No</div>
                            <b>15D, 14H, 58U, 13F</b>
                        </div>
                        <div style = {{ ...this.routeDetS, paddingLeft: '20%' }}>
                            <div>Total Price</div>
                            <b>{this.props.search.currency}2275</b>
                        </div>
                    </div>
                </div>
                <a href = '/' style = { this.btnS }>BOOK A RETURN TICKET</a>
            </section>
        );
    }

    cardS = {
        background: '#fff',
        margin: '25px 6%',
        padding: '50px',
        boxShadow: '0 0 5px 2px rgba(0, 0, 0, 0.2)',
        lineHeight: '1.6'
    }

    thankYouS = {
        display: 'flex',
        alignItems: 'center'
    }

    tickWrapS = {
        position: 'relative',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: window.color.couponBtnColor,
        marginRight: '15px'
    }

    tickS = {
        position: 'absolute',
        left: '19px',
        top: '10px',
        width: '13px',
        height: '24px',
        transform: 'rotate(45deg)',
        border: '2px solid',
        borderColor: 'transparent #fff #fff transparent',
        borderRadius: '3px'
    }

    hS = {
        margin: 0,
        fontSize: '1.5rem',
        fontWeight: 500
    }

    routeInfoS = {
        display: 'flex',
        position: 'relative',
        padding: '25px 50px',
        margin: '25px 0',
        background: window.color.searchBoxBgColor,
        color: '#fff'
    }

    routeDetS = {
        width: '50%'
    }

    arrS = {
        position: 'absolute',
        left: '45%',
        top: '35%',
        width: '20px',
        height: '20px',
        transform: 'rotate(45deg)',
        border: '2px solid',
        borderColor: '#fff #fff transparent transparent',
        borderRadius: '3px'
    }

    tktInfoS = {
        display: 'flex',
        position: 'relative',
        padding: '10px 50px'
    }

    btnS = {
        margin: '0 50px',
        background: window.color.buttonColor,
        color: '#fff',
        padding: '15px 75px',
        borderRadius: '3px',
        fontWeight: 500,
        boxShadow: '0 0 3px rgba(0, 0, 0, 0.3)'
    }
}

export default Success;